import * as React from 'react'

import { colors } from '@flowwai-frontend/shared/style-guide'

import { IconPropsType } from '../types'

const MinusIcon = (props: IconPropsType): React.ReactElement => {
   const { height = 18, width = 18, fill = colors['gray-500'], ...rest } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         fill='none'
         viewBox='0 0 18 18'
         {...rest}
      >
         <path
            stroke={fill}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
            d='M3.75 9h10.5'
         ></path>
      </svg>
   )
}

export { MinusIcon }
